import React from 'react';
import PropTypes from 'prop-types';
import BoxAndWhisker from './BoxAndWhisker';
import BoxAndWhiskerDataPoint from './BoxAndWhiskerDataPoint';

class BoxPlotInsides extends React.Component {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.instanceOf(BoxAndWhiskerDataPoint)).isRequired,
        boxWidth: PropTypes.number.isRequired,
        whiskerWidth: PropTypes.number.isRequired,
        whiskerColor: PropTypes.string.isRequired,
        pointRadius: PropTypes.number.isRequired,
        chartSeries: PropTypes.arrayOf(PropTypes.object),
        x: PropTypes.func.isRequired,
        pointOfInterestThickness: PropTypes.number.isRequired,
        xValueToSVGCoordinateMapper: PropTypes.func.isRequired,
        yValueToSVGCoordinateMapper: PropTypes.func.isRequired,
        chartBoundaries: PropTypes.object.isRequired,
        margins: PropTypes.object.isRequired,
        tooltipMouseEnter: PropTypes.func.isRequired,
        tooltipMouseLeave: PropTypes.func.isRequired,
        tooltipFormatFunction: PropTypes.func.isRequired,
        svgWindowWidth: PropTypes.number.isRequired,

    }

    _makeBox = (boxAndWhiskerDataPoint, i) => {
        let out = [];
        const {
            boxWidth,
            whiskerWidth,
            whiskerColor,
            pointRadius,
            chartSeries,
            x,
            pointOfInterestThickness,
            xValueToSVGCoordinateMapper,
            yValueToSVGCoordinateMapper,
            chartBoundaries,
            svgWindowWidth,
            margins,
            tooltipMouseEnter,
            tooltipMouseLeave,
            tooltipFormatFunction,
        } = this.props;

        return (
            <BoxAndWhisker
                svgWindowWidth={svgWindowWidth}
                tooltipFormatFunction={tooltipFormatFunction}
                boxWidth={boxWidth}
                whiskerWidth={whiskerWidth}
                pointRadius={pointRadius}
                x={x}
                pointOfInterestThickness={pointOfInterestThickness}
                boxAndWhiskerDataPoint={boxAndWhiskerDataPoint}
                xValueToSVGCoordinateMapper={xValueToSVGCoordinateMapper}
                yValueToSVGCoordinateMapper={yValueToSVGCoordinateMapper}
                whiskerColor={whiskerColor}
                chartBoundaries={chartBoundaries}
                margins={margins}
                key={i}
                onMouseEnter={tooltipMouseEnter}
                onMouseLeave={tooltipMouseLeave}
            />
        );

    }

    render() {
        const {
            data,
        } = this.props;

        return (
            <g className={'box-plot-boxes'}>
                {
                    data.map(this._makeBox)
                }
            </g>
        );
    }
};

export default BoxPlotInsides;
